import script from "./ConnectFlowHistoryItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./ConnectFlowHistoryItem.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__